const creditNumber = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

export function formatCredits(value) {
  const parsed = Number(value);
  return creditNumber.format(Number.isFinite(parsed) ? parsed : 0);
}
